/*global d3 */

export default function renderDiagramAgnostic({
  el,
  diagramData,
  handleSelect,
}) {
  if (!el || !diagramData) return;

  d3.xml("/Areas/EGH/assets/img/stunting_drivers/diagram_agnostic.svg")
    .mimeType("image/svg+xml")
    .get(function (xml) {
      const importedNode = document.importNode(xml.documentElement, true);
      const diagram = d3.select(el).each(function () {
        this.appendChild(importedNode);
      });

      const categoriesDefault = [
        {
          id: "ContextAndEnablers",
          rectHeightBase: "67px",
          rectHeightExtended: "339px",
          driverCategoryId: "Basicdrivers",
          section: 1,
        },
        {
          id: "IncreasedIncome",
          rectHeightBase: "67px",
          rectHeightExtended: "140px",
          driverCategoryId: "Underlyingdrivers",
          section: 2,
        },
        {
          id: "ImprovedFeeding",
          rectHeightBase: "107px",
          rectHeightExtended: "179px",
          driverCategoryId: "Underlyingdrivers",
          section: 3,
        },
        {
          id: "ImprovedCare",
          rectHeightBase: "65px",
          rectHeightExtended: "190px",
          driverCategoryId: "Underlyingdrivers",
          section: 4,
        },
        {
          id: "HealthyHousehold",
          rectHeightBase: "65px",
          rectHeightExtended: "161px",
          driverCategoryId: "Underlyingdrivers",
          section: 5,
        },
        {
          id: "ImprovedDietary",
          rectHeightBase: "80px",
          rectHeightExtended: "80px",
          driverCategoryId: "Immediatedrivers",
          section: 6,
        },
        {
          id: "LackOfDisease",
          rectHeightBase: "63px",
          rectHeightExtended: "63px",
          driverCategoryId: "Immediatedrivers",
          section: 7,
        },
        {
          id: "IntergenerationalTransfer",
          rectHeightBase: "61px",
          rectHeightExtended: "61px",
          driverCategoryId: "Immediatedrivers",
          section: 8,
        },
      ];

      // merge external categories data
      var data = categoriesDefault.map((d) => {
        return {
          ...d,
          ...diagramData.find((category) => category.id === d.id),
        };
      });

      // var diagram_container = d3.select(diagram.node().parentNode);

      data.forEach(function (d) {
        const thisExtendedDriver = d3.select("g#" + d.id);
        const driverCategory = d3.select("path#" + d.driverCategoryId);

        // check if data is available for the rectangle-category
        const rectangle = diagram.select(`rect#${d.id}Rect`);
        const boxNode = diagram.select(`[data-category-id=${d.id}]`).node();
        const categoryData = diagramData.find((cat) => cat.id === d.id);

        if (!categoryData || !categoryData.isEnabled) {
          // set opacity
          boxNode.style.opacity = 0.2;

          rectangle.remove();
          return;
        }

        rectangle
          .on("mouseover", function () {
            // extend rectangle
            d3.select(this).attr("height", d.rectHeightExtended);

            // show extended driver
            thisExtendedDriver.classed("active", true);

            // change color to corresponding arrows
            d3.selectAll("polygon." + d.id + "Arrow")
              .transition()
              .duration(100)
              .attr("fill", "#F37621");

            // change color to driver category title (e.g. "Basic drivers")
            driverCategory.transition().duration(100).attr("fill", "#F37621");

            // specific cases (move other drivers)
            if (d.id === "ImprovedFeeding") {
              MoveImprovedCareAndHealthyHousehold("down");
            }

            if (d.id === "ImprovedCare") {
              MoveHealthyHousehold("down");
            }

            customBehavior(d.id, "mouseover"); // special actions like moving lines and arrows
          })
          .on("mouseout", function () {
            d3.select(this).attr("height", d.rectHeightBase);
            thisExtendedDriver.classed("active", false);

            d3.selectAll("polygon." + d.id + "Arrow")
              .transition()
              .duration(100)
              .attr("fill", "#0098A7");

            driverCategory.transition().duration(100).attr("fill", "#0C4456");

            // specific cases
            if (d.id === "ImprovedFeeding") {
              MoveImprovedCareAndHealthyHousehold("up");
            }

            if (d.id === "ImprovedCare") {
              MoveHealthyHousehold("up");
            }

            customBehavior(d.id, "mouseout");
          })
          .on("click", function () {
            handleSelect(d.id);
          });
      });

      function MoveImprovedCareAndHealthyHousehold(direction) {
        var improvedCareG = d3.select("g#ImprovedCareBase"),
          improvedCareRect = d3.select("rect#ImprovedCareRect"),
          healthyHouseholdG = d3.select("g#HealthyHouseholdBase"),
          healthyHouseholdRect = d3.select("rect#HealthyHouseholdRect");

        if (direction === "down") {
          improvedCareG.attr("transform", "translate(400.000000, 224.000000)");
          improvedCareRect.attr("y", 220);

          healthyHouseholdG.attr(
            "transform",
            "translate(400.000000, 302.000000)",
          );
          healthyHouseholdRect.attr("y", 300);
        } else if (direction === "up") {
          improvedCareG.attr("transform", "translate(400.000000, 152.000000)");
          improvedCareRect.attr("y", 152);

          healthyHouseholdG.attr(
            "transform",
            "translate(400.000000, 230.000000)",
          );
          healthyHouseholdRect.attr("y", 230);
        }
      }

      function MoveHealthyHousehold(direction) {
        var healthyHouseholdG = d3.select("g#HealthyHouseholdBase"),
          healthyHouseholdRect = d3.select("rect#HealthyHouseholdRect");

        if (direction === "down") {
          healthyHouseholdG.attr(
            "transform",
            "translate(400.000000, 350.000000)",
          );
          healthyHouseholdRect.attr("y", 350);
        } else if (direction === "up") {
          healthyHouseholdG.attr(
            "transform",
            "translate(400.000000, 230.000000)",
          );
          healthyHouseholdRect.attr("y", 230);
        }
      }

      function customBehavior(driverId, mouseEvent) {
        var arrow1g = d3.select("g#Arrow1"),
          arrow2g = d3.select("g#Arrow2"),
          arrow3g = d3.select("g#Arrow3"),
          arrow4g = d3.select("g#Arrow4"),
          arrow5g = d3.select("g#Arrow5"),
          line1 = d3.select("line#Line1"),
          line2 = d3.select("line#Line2"),
          line3 = d3.select("line#Line3"),
          line4 = d3.select("line#Line4"),
          line5 = d3.select("line#Line5"),
          line6 = d3.select("line#Line6"),
          Polygon1 = d3.select("polygon#Polygon1"),
          Polygon2 = d3.select("polygon#Polygon2"),
          Polygon3 = d3.select("polygon#Polygon3"),
          Polygon4 = d3.select("polygon#Polygon4");

        switch (driverId) {
          case "IncreasedIncome":
            if (mouseEvent === "mouseover") {
              arrow1g.attr("transform", "translate(483.5,633)");
              arrow1g.select("polygon").attr("fill", "#F37621");
              arrow2g.select("polygon").attr("fill", "#F37621");

              line1.style("stroke", "#F37621");
              line2.attr("y2", 230).style("stroke", "#F37621");
            } else if (mouseEvent === "mouseout") {
              arrow1g.attr("transform", "translate(483.5,563)");
              arrow1g.select("polygon").attr("fill", "#0098A7");
              arrow2g.select("polygon").attr("fill", "#0098A7");

              line1.style("stroke", "#0098A7");
              line2.attr("y2", 160).style("stroke", "#0098A7");
            }
            break;

          case "ImprovedFeeding":
            if (mouseEvent === "mouseover") {
              line2.attr("y1", 426);

              line1.attr("y1", 426).attr("x2", 900).attr("y2", 426);

              line3
                .attr("x1", 900)
                .attr("y1", 426)
                .attr("x2", 900)
                .attr("y2", 370)
                .style("display", "inherit");

              line5
                .attr("x1", 630.5)
                .attr("y1", 379)
                .attr("x2", 630.5)
                .attr("y2", 112)
                .style("display", "inherit");

              line6
                .attr("x1", 631)
                .attr("y1", 379)
                .attr("x2", 641)
                .attr("y2", 379)
                .style("display", "inherit");

              arrow2g.attr("transform", "translate(787,774)");

              arrow2g.select("polygon").style("transform", "rotate(-90deg)");

              arrow5g.select("polygon").style("display", "inherit");
              arrow5g
                .attr("transform", "translate(233,265)")
                .style("display", "inherit");

              Polygon1.style("display", "none");

              Polygon4.style("display", "none");

              d3.select("g#ImprovedFeedingBase").style("display", "none");
            } else if (mouseEvent === "mouseout") {
              line2.attr("y1", 349);

              line1.attr("y1", 349).attr("x2", 870).attr("y2", 349);

              line3
                .attr("x1", 870)
                .attr("y1", 339)
                .attr("x2", 870)
                .attr("y2", 340)
                .style("display", "none");

              line5.style("display", "none");
              line6.style("display", "none");

              arrow2g.attr("transform", "translate(467,236)");

              arrow2g.select("polygon").style("transform", "rotate(0deg)");

              arrow5g.select("polygon").style("display", "none");

              Polygon1.style("display", "inherit");

              Polygon3.style("display", "inherit");
              Polygon4.style("display", "inherit");

              d3.select("g#ImprovedFeedingBase").style("display", "inherit");
            }
            break;

          case "ImprovedCare":
            if (mouseEvent === "mouseover") {
              let newYPos = 470;

              line2.attr("y1", newYPos);

              line1.attr("y1", newYPos).attr("x2", 900).attr("y2", newYPos);

              line3
                .attr("x1", 900)
                .attr("y1", newYPos)
                .attr("x2", 900)
                .attr("y2", 370)
                .style("display", "inherit");

              line5
                .attr("x1", 630.5)
                .attr("y1", 179)
                .attr("x2", 630.5)
                .attr("y2", 423)
                .style("display", "inherit");

              line6
                .attr("x1", 631)
                .attr("y1", 422)
                .attr("x2", 641)
                .attr("y2", 422)
                .style("display", "inherit");

              arrow2g.attr("transform", "translate(787,774)");

              arrow5g.select("polygon").style("display", "inherit");
              arrow5g
                .attr("transform", "translate(233,309)")
                .style("display", "inherit");

              arrow2g.select("polygon").style("transform", "rotate(-90deg)");

              Polygon2.style("display", "none");

              Polygon4.style("display", "none");

              line4.style("display", "inherit").style("stroke", "#F37621");

              arrow3g
                .select("polygon")
                .style("display", "inherit")
                .attr("fill", "#F37621");
            } else if (mouseEvent === "mouseout") {
              line2.attr("y1", 349);

              line1.attr("y1", 349).attr("x2", 870).attr("y2", 349);

              line3
                .attr("x1", 870)
                .attr("y1", 339)
                .attr("x2", 870)
                .attr("y2", 340)
                .style("display", "none");

              line5.style("display", "none");
              line6.style("display", "none");

              arrow2g.attr("transform", "translate(467,236)");

              arrow2g.select("polygon").style("transform", "rotate(0deg)");
              arrow5g.select("polygon").style("display", "none");

              Polygon2.style("display", "inherit");

              Polygon4.style("display", "inherit");

              line4.style("display", "none").style("stroke", "#0098A7");

              arrow3g
                .select("polygon")
                .style("display", "none")
                .attr("fill", "#0098A7");
            }
            break;

          case "HealthyHousehold":
            if (mouseEvent === "mouseover") {
              let newYPos = 447;

              line2.attr("y1", newYPos);

              line1.attr("y1", newYPos).attr("x2", 900).attr("y2", newYPos);

              line3
                .attr("x1", 900)
                .attr("y1", newYPos)
                .attr("x2", 900)
                .attr("y2", 370)
                .style("display", "inherit");

              arrow2g.attr("transform", "translate(787,774)");

              arrow2g.select("polygon").style("transform", "rotate(-90deg)");
            } else if (mouseEvent === "mouseout") {
              line2.attr("y1", 349);

              line1.attr("y1", 349).attr("x2", 870).attr("y2", 349);

              line3
                .attr("x1", 870)
                .attr("y1", 339)
                .attr("x2", 870)
                .attr("y2", 340)
                .style("display", "none");

              arrow2g.attr("transform", "translate(467,236)");

              arrow2g.select("polygon").style("transform", "rotate(0deg)");
            }
            break;

          case "LackOfDisease":
            if (mouseEvent === "mouseover") {
              arrow4g
                .select("polygon")
                .style("display", "inherit")
                .attr("fill", "#F37621");
            } else if (mouseEvent === "mouseout") {
              arrow4g
                .select("polygon")
                .style("display", "none")
                .attr("fill", "#0098A7");
            }

            break;
        }
      }
    });
}
